"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.findingsSize = void 0;
const vue_1 = require("vue");
const _emptyFindings = () => ({
    brands: [],
    categories: [],
    others: [],
});
const findings = (0, vue_1.ref)(_emptyFindings());
const hasFindings = (0, vue_1.computed)(() => findings.value.brands.length > 0 || findings.value.categories.length > 0 || findings.value.others.length > 0);
exports.findingsSize = (0, vue_1.computed)(() => findings.value.brands.length + findings.value.categories.length + findings.value.others.length);
const _populateFindings = (result) => {
    var _a;
    const findings = _emptyFindings();
    const _epoqFindings = (_a = result.findings) === null || _a === void 0 ? void 0 : _a.finding;
    if (_epoqFindings) {
        (Array.isArray(_epoqFindings) ? _epoqFindings : [_epoqFindings]).forEach((item) => {
            switch (item.suggestion["@field"]) {
                case "g:product_type": {
                    findings.categories.push(item.suggestion.$);
                    break;
                }
                case "g:brand": {
                    findings.brands.push(item.suggestion.$);
                    break;
                }
                default: {
                    findings.others.push(item.suggestion.$);
                }
            }
        });
    }
    return findings;
};
const setFindings = (result) => {
    findings.value = _populateFindings(result);
};
function useFindings() {
    return {
        findings,
        hasFindings,
        setFindings,
    };
}
exports.default = useFindings;
